import React from 'react';
import WysiwygEditor from '../../../Shared/WysiwygEditor';
import { FaLock } from 'react-icons/fa';
import { MdPeopleAlt } from 'react-icons/md';

const NotesTab = ({
  publicNotes,
  privateNotes,
  onPublicNotesChange,
  onPrivateNotesChange,
  onSavePublicNotes,
  onSavePrivateNotes,
  savingPublic,
  savingPrivate,
  className,
}) => {
  return (
    <div className={`flex flex-col md:flex-row gap-3 ${className}`}>
      {/* Shared Notes Editor */}
      <div className="w-full md:w-1/2 border rounded px-3 pt-2 pb-3 relative">
        <div className="absolute top-2 right-2">
          <button
            type="button"
            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-xs px-3 py-1 disabled:opacity-75"
            onClick={onSavePublicNotes}
            disabled={savingPublic}
          >
            {savingPublic ? 'Saving...' : 'Save'}
          </button>
        </div>
        <div className="mb-2">
          <div className="flex items-center gap-2">
            <MdPeopleAlt size={18} className="text-gray-700 mb-1 mt-1" />
            <h3 className="font-semibold">Shared Notes</h3>
          </div>
          <p className="text-sm text-gray-500">Viewable by the student</p>
        </div>
        <WysiwygEditor
          HTMLInput={publicNotes}
          onChange={onPublicNotesChange}
          minHeight="200px"
          maxHeight="250px"
          minWidth="490px"
          maxWidth="490px"
        />
      </div>

      {/* Private Notes Editor */}
      <div className="w-full md:w-1/2 border rounded px-3 pt-2 pb-3 relative">
        <div className="absolute top-2 right-2">
          <button
            type="button"
            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-xs px-3 py-1 disabled:opacity-75"
            onClick={onSavePrivateNotes}
            disabled={savingPrivate}
          >
            {savingPrivate ? 'Saving...' : 'Save'}
          </button>
        </div>
        <div className="mb-2">
          <div className="flex items-center gap-2">
            <FaLock size={14} className="text-gray-700 mb-1 mt-1" />
            <h3 className="font-semibold">Private Notes</h3>
          </div>
          <p className="text-sm text-gray-500">My eyes Only</p>
        </div>
        <WysiwygEditor
          HTMLInput={privateNotes}
          onChange={onPrivateNotesChange}
          minHeight="200px"
          maxHeight="250px"
          minWidth="490px"
          maxWidth="490px"
        />
      </div>
    </div>
  );
};

export default NotesTab;
